import React, { useState } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Typography,
  Select,
  Modal,
  message,
} from "antd";
import OtpInput from "react-otp-input";
import "./styles.css";
import hooks from "hooks";
import { generateOTP, verifyOTP } from "api/authApis";
import { updateAccountDetails, updateMobileNumber } from "api/customApis";

const { Option } = Select;

const { Title } = Typography;
export default function MobileField({
  label,
  editable,
  countryCodes,
  mobile,
  country,
  fetchData,
  email,
}) {
  const [editMode, setEditMode] = useState(false);
  const [mobileNum, setMobileNum] = useState(mobile);
  const [countryCode, setCountryCode] = useState(country?.id);
  const [currentCountry, setCurrentCountry] = useState(country);

  const { seconds, start, stop, reset } = hooks.useTimer({ seconds: 180 });

  const [labelValue, setLabelValue] = useState(
    mobile ? `+${country.phonecode}-${mobile}` : "Not Added"
  );

  const [showOTPModal, setShowOTPModal] = useState(false);
  const [haserrorOTP, setHaserrorOTP] = useState(false);
  const [OtpValue, setOtpValue] = useState();

  const handleGenerateOTP = () => {
    if (mobileNum && countryCode) {
      generateOTP({ email, mobile: mobileNum, country: countryCode })
        .then(() => {
          start();
          if (!showOTPModal) setShowOTPModal(true);
        })
        .catch((e) => {
          message.error(`Failed to generate OTP`);
        });
    } else {
      if (!mobileNum) {
        message.error("Please enter your contact number");
      } else {
        message.error("Please enter your country code");
      }
    }
  };

  const handleverifyOTP = () => {
    verifyOTP({ otp: OtpValue })
      .then((res) => {
        if (res.data.verified) {
          stop();
          handleUpdate();
          setEditMode(false);
          setShowOTPModal(false);
        } else {
          setHaserrorOTP(true);
        }
      })
      .catch((e) => {
        setHaserrorOTP(true);
      });
  };

  const formatSeconds = (countDown) => {
    const sec = seconds % 60;
    const secLabel = sec < 10 ? `0${sec}` : sec;
    const min = Math.floor(seconds / 60);
    if (min) {
      return `0${min}:${secLabel} minutes`;
    }
    return `00:${secLabel} seconds`;
  };

  const toggleMode = () => {
    setEditMode((state) => !state);
  };

  const renderReadMode = () => {
    return <div style={{ color: "#040E0C", fontSize: 16 }}>{labelValue}</div>;
  };

  const handleUpdate = () => {
    updateMobileNumber({ mobile: mobileNum, country: countryCode })
      .then((res) => {
        setLabelValue(`+${currentCountry?.phonecode}-${mobileNum}`);
        message.success(`Mobile number updated successfully`);
        fetchData();
      })
      .catch(() => {
        message.error(`Failed to update mobile number`);
      });
  };

  const handleBack = () => {
    stop();
    setShowOTPModal(false);
  };

  const handleResendOTP = () => {
    reset();
    handleGenerateOTP();
  };

  const handleOtpModal = () => {
    return (
      <div>
        <Modal
          keyboard={true}
          closable={false}
          visible={showOTPModal}
          destroyOnClose={true}
          footer={null}
          centered
          bodyStyle={{ top: "19em", borderRadius: "8px" }}
        >
          <Row style={{ fontSize: "18px", fontWeight: "bold" }}>
            {`Enter the OTP received on +${currentCountry?.phonecode}-${mobileNum}.`}
          </Row>
          <Row
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginTop: "1.5em",
              marginBottom: "0.8em",
            }}
          >
            OTP valid for {formatSeconds(seconds)}
          </Row>
          <Row style={{ width: "100%", marginBottom: "0.8em" }}>
            <Col span={24}>
              <OtpInput
                isInputNum
                containerStyle={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
                value={OtpValue}
                onChange={(e) => {
                  setOtpValue(e);
                }}
                numInputs={6}
                inputStyle={{
                  width: "40px",
                  height: "3rem",
                  fontSize: "25px",
                  borderRadius: "8px",
                  border: "1px solid #C9E4DF",
                }}
                isInputSecure={true}
                hasErrored={haserrorOTP}
                errorStyle={{ border: "1px solid red" }}
              />
            </Col>
          </Row>
          {haserrorOTP ? (
            <Row
              style={{
                color: "#F34D4D",
                fontSize: "12px",
                fontWeight: "500",
                height: "2.5em",
                background: "#FDDBDB80",
                padding: "5px",
                marginBottom: "0.5em",
              }}
            >
              The OTP you have entered is not valid
            </Row>
          ) : null}
          <Row>
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bolder",
                color: "#0B7764",
                cursor: "pointer",
                paddingBottom: "7em",
              }}
              onClick={handleResendOTP}
            >
              Resend OTP
            </span>
          </Row>

          <Row>
            <Col span={11}>
              <Button
                type="Ghost"
                size="large"
                style={{
                  width: "100%",
                  // height: "3em",

                  border: "1px solid grey",
                  borderRadius: 4,
                  fontWeight: "bold",
                  color: "grey",
                }}
                onClick={handleBack}
              >
                Go Back
              </Button>
            </Col>
            <Col span={11} offset={2}>
              <Button
                size="large"
                style={{
                  width: "100%",
                  // width: "12em",
                  // height: "3em",
                  fontWeight: "bold",
                  color: "white",
                  backgroundColor: "#363E3D",
                  border: "1px solid white",
                  borderRadius: 4,
                  // left: "5.5em",
                }}
                onClick={handleverifyOTP}
              >
                Verify
              </Button>
            </Col>
          </Row>

          <Row
            style={{
              color: "#4F5655",
              fontSize: "14px",
              forntWeight: "normal",
              paddingTop: "0.8em",
            }}
            justify="space-around"
            align="middle"
          >
            <Col>Need more help? Contact support@sourcewiz.co</Col>
          </Row>
        </Modal>
      </div>
    );
  };

  const renderButtons = () => {
    return (
      <Row align="bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <Button
          size="large"
          style={{
            color: "white",
            backgroundColor: "#363E3D",
            border: "1px solid white",
            borderRadius: 4,
          }}
          disabled={mobile === mobileNum && countryCode === country?.id}
          onClick={handleGenerateOTP}
        >
          {mobile ? "Update" : "Submit"}
        </Button>
        <Button
          size="large"
          style={{
            color: "#4F5655",
            backgroundColor: "white",
            border: "1px solid #CDCFCE",
            borderRadius: 4,
            marginLeft: "1rem",
          }}
          onClick={() => {
            setEditMode(false);
          }}
        >
          Cancel
        </Button>
      </Row>
    );
  };

  const handleNumberData = (e) => {
    const { value } = e.target;
    var reg = /\d+/;
    if (reg.test(value) || value === "") {
      setMobileNum(value);
    }
  };

  const renderEditMode = () => {
    return (
      <div
        style={{ marginTop: "1rem", display: "flex", flexDirection: "column" }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Select
            dropdownAlign={{ points: ["bl", "tl"] }}
            allowClear
            className="country_codes_select"
            showSearch
            style={{ width: 200, marginRight: "0.5rem" }}
            placeholder="code"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
            onChange={(value, e) => {
              setCurrentCountry(e?.data);
              setCountryCode(value);
            }}
            required={true}
            defaultValue={country?.id}
          >
            {countryCodes.map((item) => {
              return (
                <Option
                  data={item}
                  value={item.id}
                >{`${item.iso3}+(${item.phonecode})`}</Option>
              );
            })}
          </Select>

          <Input
            onWheel={(e) => e.currentTarget.blur()}
            size="large"
            onChange={handleNumberData}
            value={mobileNum}
            type="number"
          />
        </div>
        <div>{renderButtons()}</div>
      </div>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        borderBottom: "1px solid #E6E7E7",
        width: window.innerWidth > 900 ? "70%" : "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            color: "#4F5655",
            marginBottom: "0.5rem",
          }}
        >
          <Title level={5} type="secondary">
            {label}
          </Title>
        </div>
        {editable && !editMode && (
          <div
            onClick={toggleMode}
            style={{
              cursor: "pointer",
              color: "#0B7764",
              paddingRight: "1rem",
            }}
          >
            {mobile ? "Edit" : "Add"}
          </div>
        )}
      </div>
      {editMode ? renderEditMode() : renderReadMode()}
      {<div>{handleOtpModal()}</div>}
    </div>
  );
}
